
@for (color of colors; track color.key) {
  <div
    class="ed-preview-color"
    [ngClass]="{'e--active': this.current === color.key}"
    [ngStyle]="{'--theme-color': color.hex}"
    (click)="select(color)"
  >
    <span>{{ color.label }}</span>
  </div>
}
